import './App.css';
import { BrowserRouter } from 'react-router-dom';
import RouterNavigation from './router';
import UiLoader from './components/uiLoader';
import { useSelector } from 'react-redux';

function App() {
  const spinner=useSelector(state => state.isLoading?.loading);
  return (
    <div>
      <BrowserRouter>
      <UiLoader spinning={spinner}/>
      <RouterNavigation/>
      </BrowserRouter>
    </div>
  );
}

export default App;
